import React from 'react';
import PropTypes from 'prop-types';
import { furnitureSelected } from './data/utils';
import FurnitureContent from './content/FurnitureContent';
import FurnitureExpanded from './content/FurnitureExpanded';

const Furniture = ({ faqData = {}, expanded = false }) => {
  const furnitureTypesSelected = furnitureSelected(faqData);
  if (expanded) {
    return (
      <>
        <FurnitureExpanded furnitureTypesSelected={furnitureTypesSelected} faqData={faqData} />
      </>
    );
  }
  return (
    <>
      <FurnitureContent furnitureTypesSelected={furnitureTypesSelected} faqData={faqData} />
    </>
  );
};

Furniture.propTypes = {
  faqData: PropTypes.object,
  expanded: PropTypes.bool
};

export default Furniture;
